// src/components/PartnerGrid.tsx
import { motion } from "framer-motion";
import { Partner } from "@/types";

interface PartnerGridProps {
  partners: Partner[];
  columns?: 3 | 4 | 6;
}

export const PartnerGrid = ({ partners, columns = 4 }: PartnerGridProps) => {
  const gridCols = {
    3: "grid-cols-2 md:grid-cols-3",
    4: "grid-cols-2 md:grid-cols-3 lg:grid-cols-4",
    6: "grid-cols-2 md:grid-cols-3 lg:grid-cols-6",
  };

  return (
    <div className={`grid ${gridCols[columns]} gap-6 sm:gap-8`}>
      {partners.map((partner, idx) => (
        <motion.div
          key={partner.id}
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.4, delay: idx * 0.05 }}
          whileHover={{ scale: 1.05, y: -4 }}
          className="group"
        >
          <div className="relative aspect-video rounded-xl bg-card border border-border p-6 flex items-center justify-center shadow-md hover:shadow-xl hover:border-primary/30 transition-all duration-500 overflow-hidden">
            {/* Gradient overlay on hover */}
            <div className="absolute inset-0 bg-gradient-to-br from-primary/0 to-primary/0 group-hover:from-primary/5 group-hover:to-accent/5 transition-all duration-500" />
            
            {/* Logo - COLORFUL (no grayscale) */}
            <img
              src={partner.logo}
              alt={partner.name.en}
              className="relative z-10 w-full h-full object-contain transition-all duration-500 group-hover:brightness-110"
              loading="lazy"
            />
            
            {/* Subtle shine effect on hover */}
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000" />
          </div>
        </motion.div>
      ))}
    </div>
  );
};
